export default __webpack_public_path__ + "static/media/sas.deac04cf.png";